import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, IndexRoute } from 'react-router'
import { Provider } from 'react-redux'
import store, { history } from './store'

import App from './components/App'
import InputGrid from './components/InputGrid'
import ChangeLog from './components/ChangeLog'
import About from './components/About'
import Contact from './components/Contact'

const routes = (
  <Provider store={store}>
    <Router history={history}>
      <Route path='/' component={App}>
        <IndexRoute component={InputGrid}></IndexRoute>
        <Route path='/changelog' component={ChangeLog}></Route>
        <Route path='/howitworks' component={About}></Route>
        <Route path='/contact' component={Contact}></Route>
      </Route>
    </Router>
  </Provider>
)

ReactDOM.render(
  routes,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js